import { defaultPaymentDetailsState, paymentDetailsModel$ } from '../VehicleCollectionSubjects';

import { useRxjsStore } from './useRxjsStore';

export const usePaymentDetailsSub = () => useRxjsStore(paymentDetailsModel$, defaultPaymentDetailsState);
